<h2 mat-dialog-title>Registrar asistencia en reuniones</h2>
<mat-dialog-content cdkScrollable>
  @if (currentMeeting()) {
    <div class="meeting-info">
      <div class="meeting-header">
        @if (currentMeeting()?.relatable) {
          <span class="company-product-info">
            <img [src]="currentMeeting()!.relatable!.logo_url" [alt]="currentMeeting()!.relatable!.title" class="company-product-logo" />
            {{ currentMeeting()!.relatable!.title }}
          </span>
        }
        <span class="meeting-detail">
          <mat-icon class="icon-small">schedule</mat-icon>
          {{ currentMeeting()!.from_date | date: 'dd/MM/y HH:mm' : '' : 'es-ES' }}
        </span>
        <span class="meeting-detail">
          <mat-icon class="icon-small" [matTooltip]="workingTimeCategoryTooltip()">info</mat-icon>
          {{ currentMeeting()!.title }}
        </span>
      </div>
    </div>

    <div class="attendance-options">
      <p><strong>¿Asististe a esta reunión?</strong></p>
      <mat-form-field appearance="outline" class="meeting-attendance-field" subscriptSizing="dynamic">
        <mat-select [value]="selectedAttendance()" (selectionChange)="selectedAttendance.set($event.value)">
          @for (status of MeetingAttendanceStatusOptions; track status) {
            <mat-option [value]="status">{{ MeetingAttendanceStatusLabels[status] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedAttendance() === MeetingAttendanceStatus.DONT_KNOW) {
        <mat-form-field appearance="outline" class="meeting-attendance-field" subscriptSizing="dynamic">
          <mat-label>Razón</mat-label>
          <textarea
            matInput
            [(ngModel)]="dontKnowReason"
            [minlength]="dontKnowReasonMinLength"
            [maxlength]="dontKnowReasonMaxLength"
            rows="3"
            [class.textarea-field-error]="isOwnDontKnowReasonInvalid()"
            required
          ></textarea>
          <mat-hint align="end"
            ><span [class.hint-below-min]="dontKnowReason().length < dontKnowReasonMinLength">{{ dontKnowReason().length }}</span> /
            {{ dontKnowReasonMaxLength }}</mat-hint
          >
        </mat-form-field>
      }
    </div>

    @if (shouldShowColleaguesSection()) {
      <div class="colleagues-table-wrapper">
        <p><strong>¿Y tus compañeros?</strong></p>
        <table class="colleagues-table">
          <tbody>
            @for (colleague of currentColleagues(); track colleague.id) {
              <tr class="colleague-row">
                <td class="colleague-name-cell">
                  <div class="colleague-info">
                    <app-user-profile-picture [user]="colleague" [css_class]="'colleague-avatar'" [alt]="colleague.name" />
                    <span>{{ colleague.name }} {{ colleague.surnames }}</span>
                  </div>
                </td>
                <td class="colleague-select-cell">
                  <mat-form-field appearance="outline" class="meeting-attendance-field-small" subscriptSizing="dynamic">
                    <mat-label>Asistencia</mat-label>
                    <mat-select
                      [value]="colleaguesAttendance()[colleague.id].attendance"
                      (selectionChange)="setColleagueAttendance(colleague.id, $event.value ?? MeetingAttendanceStatus.YES)"
                    >
                      @for (status of MeetingAttendanceStatusOptions; track status) {
                        <mat-option [value]="status">{{ MeetingAttendanceStatusLabels[status] }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (colleaguesAttendance()[colleague.id]?.attendance === MeetingAttendanceStatus.DONT_KNOW) {
                    <mat-form-field
                      appearance="outline"
                      class="meeting-attendance-field-small colleague-reason-field"
                      subscriptSizing="dynamic"
                    >
                      <mat-label>Razón</mat-label>
                      <textarea
                        matInput
                        [ngModel]="colleaguesAttendance()[colleague.id].dontKnowReason"
                        (ngModelChange)="setColleagueDontKnowReason(colleague.id, $event)"
                        [minlength]="dontKnowReasonMinLength"
                        [maxlength]="dontKnowReasonMaxLength"
                        rows="2"
                        [class.textarea-field-error]="colleagueDontKnowReasonInvalidMap()[colleague.id]"
                        required
                      ></textarea>
                      <mat-hint align="end"
                        ><span
                          [class.hint-below-min]="colleaguesAttendance()[colleague.id].dontKnowReason.length < dontKnowReasonMinLength"
                          >{{ colleaguesAttendance()[colleague.id].dontKnowReason.length }}</span
                        >
                        / {{ dontKnowReasonMaxLength }}</mat-hint
                      >
                    </mat-form-field>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (should_show_trip_section()) {
      <div class="driver-section">
        <p><strong>¿Quién puso coche?</strong></p>
        <mat-form-field appearance="outline" class="meeting-attendance-field" subscriptSizing="dynamic">
          <mat-select [value]="selected_trip_option()" (selectionChange)="selected_trip_option.set($event.value)">
            <mat-select-trigger>{{ selected_trip_option_label() }}</mat-select-trigger>
            @for (participant of trip_participants(); track participant.id) {
              <mat-option [value]="participant.id">
                <span class="driver-option">
                  <span class="driver-option-media">
                    <app-user-profile-picture [user]="participant" [css_class]="'driver-avatar'" [alt]="participant.name" />
                  </span>
                  <span class="driver-option-label">{{ participant.name }} {{ participant.surnames }}</span>
                </span>
              </mat-option>
            }
            <mat-option [value]="public_transport_option">
              <span class="driver-option driver-option-public-transport">
                <span class="driver-option-media">
                  <mat-icon class="driver-transport-icon">directions_bus</mat-icon>
                </span>
                <span class="driver-option-label">{{ public_transport_label() }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" [disabled]="!canSubmit() || isSubmitting()" (click)="submit()">
    <mat-icon class="save-icon">save</mat-icon>
    @if (isLastMeeting()) {
      Guardar
    } @else {
      Guardar ({{ currentMeetingIndex() + 1 }} de {{ pendingMeetingAttendances().length }})
    }
  </button>
</mat-dialog-actions>
